calendars-phase
  h5
    span.label(style="background: {phaseColor()}") {phaseName()}
  .wrap
    .order(each="{orders()}")
      a(href="{o.show_path}" target="_blank")
        span.job_no.badge.badge-inverse-info
          | { o.job_no }
      span.client_name { o.client_name }
      span.product
        span.product_name { o.product_name }
        span.product_id { o.product_product_id }
      span.phase-special(if="{phaseIdentity() == 'delivery'}")
        span.delivery_options
          | { delivery_options(t) }
        span.delivery_who
          span(if="{delivery_who(t) == 1}") {locale().who_client}
          span(if="{delivery_who(t) == 2}") {locale().who_partner}
          span(if="{delivery_who(t) == 4}") {locale().who_mc}
      span.phase-special(if="{phaseIdentity() == 'casting'}")
        span.num
          span.planned.badge.badge-primary(if="{memo(t)}") { memo(t) }
          span.planned.badge.badge-danger(if="{!memo(t)}") !
          span.sep /
          span.required_num { casting_num(t) }
        span.material(if="{material(o)}") { material(o) }
        span.material(if="{!material(o)}")
          span.badge.badge-danger !
          span &nbsp;{ locale().no_material}
        span.heat_treatment(if="{heat_treatment(o)}")
          span.sep : { heat_treatment(o) }
      span.phase-special(if="{requiredNumPhase()}")
        span.num
          span.planned.badge.badge-primary(if="{memo(t)}") { memo(t) }
          span.planned.badge.badge-danger(if="{!memo(t)}") !
          span.sep /
          span.required_num { o.required_num }
      span.task_description(if="{taskDescription(t)}")
        span { taskDescription(t) }
  script(type="typescript").
    this.mixin('calendars.phase');
  style(scoped).
    h5 span.label {
      color: #fff;
    }
    .order {
      margin-top: .5rem;
      margin-bottom: .5rem;
    }
    .order > span{
      display: inline-block;
    }
    .client_name,
    .num,
    .material,
    .task_description {
      margin-left: 1rem;
    }
    .task_description {
      font-size: .75rem;
    }
    .client_name,
    .client_person_name,
    .product_name,
    .product_id {
      margin-right: .5rem;
    }
    .product_id {
      font-style: italic;
    }
    .delivery_options{
      margin-right: 1px;
    }
    .delivery_options,
    .delivery_who {
      font-size: 80%;
      border: 1px solid #ccc;
      padding: 2px 4px;
    }
